/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SharedHotelRateCharge
 */
export interface SharedHotelRateCharge {
  /**
   *
   * @type {string}
   * @memberof SharedHotelRateCharge
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelRateCharge
   */
  value: string;
}

/**
 * Check if a given object implements the SharedHotelRateCharge interface.
 */
export function instanceOfSharedHotelRateCharge(
  value: object
): value is SharedHotelRateCharge {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  return true;
}

export function SharedHotelRateChargeFromJSON(
  json: any
): SharedHotelRateCharge {
  return SharedHotelRateChargeFromJSONTyped(json, false);
}

export function SharedHotelRateChargeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SharedHotelRateCharge {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    value: json["value"],
  };
}

export function SharedHotelRateChargeToJSON(json: any): SharedHotelRateCharge {
  return SharedHotelRateChargeToJSONTyped(json, false);
}

export function SharedHotelRateChargeToJSONTyped(
  value?: SharedHotelRateCharge | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    value: value["value"],
  };
}
